import { Conversation } from '@shared/api/api-loop/models/conversation';
import { SplitStateEnum } from '@shared/api/api-loop/models/split-state-enum';

/**
 * Whether the conversation was closed on the server and can therefore no longer receive replies.
 *
 * Single source of truth for closed-conversation checks (FE-211). Closing blocks the reply paths
 * (mail reply actions, quick reply, channel wysiwyg) — the chat input deliberately keeps working,
 * since chat messages stay available on a closed thread.
 */
export function isConversationClosed(conversation: Conversation | null | undefined): boolean {
  return conversation?.splitOptions?.state === SplitStateEnum.CLOSED;
}
